/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface StoreGetOneDto {
    cdStore?: number;
    dsImg?: string;
    dsName?: string;
    dsStoreTypeName?: string;
    dsSlogan?: string;
    dsPhone?: string;
    dsCityName?: string;
    isEnabled?: boolean;
    isOpen?: boolean;
    isRealOpen?: boolean;
    isTrending?: boolean;
    cdCity?: number;
    cdStoreType?: number;
    dsEmail?: string;
    dsAddress?: string;
    dsPostalCode?: string;
    dtOpeningTime?: Date;
    dtClosingTime?: Date;
    dtOpeningTime2?: Date;
    dtClosingTime2?: Date;
    nmDeliveryTime?: number;
    qtPersonCost?: number;
    qtLatitude?: number;
    qtLongitude?: number;
    qtAppCommission?: number;
    dsLogo?: string;
    dsApiMeli?: string;
    dsMeliPublicKey?: string;
    storeImages?: Array<string>;
}
